<mat-toolbar *ngIf="simulation$ | async as simulation" color="primary" class="mat-elevation-z6 app-simulation-title">
  <button (click)="back()" mat-icon-button i18n-title title="Back to network list">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span fxFlex>
    {{simulation.name}}
  </span>

  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="config()" i18n-title title="Configure Network">
      <mat-icon>edit</mat-icon>
      <span i18n>EDIT</span>
    </button>
    <button mat-menu-item (click)="remove()" i18n-title title="Remove Network">
      <mat-icon>delete</mat-icon>
      <span i18n>Remove</span>
    </button>
  </mat-menu>

</mat-toolbar>

<app-loading *ngIf="isLoading"></app-loading>
